module.exports = __webpack_public_path__ + "img/pending.fdf694cf.svg";